import { render, staticRenderFns } from "./CatalogosTable.vue?vue&type=template&id=652f8fd9"
import script from "./CatalogosTable.vue?vue&type=script&lang=js"
export * from "./CatalogosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports